import { render, staticRenderFns } from "./UserActivityLogsView.vue?vue&type=template&id=5712e110&scoped=true&"
import script from "./UserActivityLogsView.vue?vue&type=script&lang=ts&"
export * from "./UserActivityLogsView.vue?vue&type=script&lang=ts&"
import style0 from "./UserActivityLogsView.vue?vue&type=style&index=0&id=5712e110&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5712e110",
  null
  
)

export default component.exports